import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";

// Components
import ErrorDialog from "../../utils/dialogs/ErrorDialog";
import TrainingSurveyItemAdmin from "./TrainingSurveyItemAdmin";
import DeleteConfirmationDialog from "../../utils/dialogs/DeleteConfirmationDialog";
import Button from "../../utils/Button";
import AddNewTrainingSurveysItemDialog from "../../utils/dialogs/AddNewTrainingSurveysItemDialog";

// State
import { userTokenUpdate } from "../../../store/actions/user";

class SearchTrainingSurveys extends Component {
	constructor(props) {
		super(props);

		this.state = {
			data: props.items,
			showErrorDialog: false,
			showDeleteConfirmationDialog: false,
			deleteItem: {},
			addNewLoading: false,
			showNewItemDialog: false
		};
	}

	// ===================================================================================
	//  INPUT HANDLERS
	// ===================================================================================
	updateTitle = (event, index) => {
		const { id, value } = event.target;

		this.setState({
			data: [
				...this.state.data.map((item, i) => {
					if (i !== index) {
						return item;
					}

					return {
						...item,
						[id]: value,
						titleChanged: true
					};
				})
			]
		});
	};

	// ===================================================================================
	//  ADD
	// ===================================================================================
	/**
	 *
	 * We have to accept an object as the arguments so we can easily pass it in from a key handler, etc.
	 * .apply() doesn't work super well.  Maybe it does, but it's lame to use for every other use case.
	 *
	 */
	addNewItem = args => {
		const { title, url } = args;

		this.setState(
			{
				newItemInProgress: true,
				newItemError: null
			},
			() => {
				const { user } = this.props;

				const data = {
					title,
					url
				};

				const token = user.token;
				const AUTH_HEADER = {
					Authorization: process.env.REACT_APP_SITE_KEY + ":Bearer " + token
				};
				return axios
					.post(process.env.REACT_APP_API_URL + "training-surveys/add", data, {
						headers: AUTH_HEADER
					})
					.then(response => {
						if (!!response.data.token) {
							this.props.userTokenUpdate("admin", response.data.token);
						}

						// ===================================
						//  ERROR
						// ===================================
						if (
							response.status !== 200 ||
							(response.data.status && response.data.status !== 200)
						) {
							this.setState({
								newItemInProgress: false,
								newItemError: response.data.errors
							});
						}
						// ===================================
						//  SUCCESS
						// ===================================
						else {
							// Hide "new item" dialog, reset any flags, and add the new item to state
							this.setState({
								newItemInProgress: false,
								showNewItemDialog: false,
								data: [response.data.survey, ...this.state.data]
							});
						}
					})
					.catch(err => {
						this.setState({
							newItemInProgress: false,
							newItemError: err.toString()
						});
					});
			}
		);
	};

	// ===================================================================================
	//  UPDATE
	// ===================================================================================
	handleUpdate = editedItem => {
		let itemIndex = null;

		// Set state of saving group
		const savedDocState = this.state.data.map((item, i) => {
			if (item.id !== editedItem.id) {
				return item;
			}

			itemIndex = i;

			return { ...item, saving: true, successfull: false };
		});

		this.setState(
			{
				data: [...savedDocState]
			},
			() => {
				const { user } = this.props;

				const data = {
					...editedItem
				};

				const token = user.token;
				const AUTH_HEADER = {
					Authorization: process.env.REACT_APP_SITE_KEY + ":Bearer " + token
				};
				return axios
					.post(process.env.REACT_APP_API_URL + "training-surveys", data, {
						headers: AUTH_HEADER
					})
					.then(response => {
						if (!!response.data.token) {
							this.props.userTokenUpdate("admin", response.data.token);
						}

						// ===================================
						//  ERROR
						// ===================================
						if (
							response.status !== 200 ||
							(response.data.status && response.data.status !== 200)
						) {
							this.setState({
								showErrorDialog: true,
								errors: response.data.errors
							});

							this.resetItemState(itemIndex);
						}
						// ===================================
						//  SUCCESS
						// ===================================
						else {
							// Reset saving status for group
							this.resetItemState(itemIndex, true);
						}
					})
					.catch(err => {
						this.setState({
							showErrorDialog: true,
							errors: err.toString()
						});
						this.resetItemState(itemIndex);
					});
			}
		);
	};

	// ===================================================================================
	//  DELETE
	// ===================================================================================
	handleDelete = itemId => {
		let itemIndex = null;

		// Set state of saving group
		const savedDocState = this.state.data.map((item, i) => {
			if (item.id !== itemId) {
				return item;
			}

			itemIndex = i;

			return { ...item, deleting: true };
		});

		this.setState(
			{
				data: [...savedDocState],
				deleteItem: {
					...this.state.deleteItem,
					deletionInProgress: true
				}
			},
			() => {
				const { user } = this.props;

				const token = user.token;
				const AUTH_HEADER = {
					Authorization: process.env.REACT_APP_SITE_KEY + ":Bearer " + token
				};
				return axios
					.delete(process.env.REACT_APP_API_URL + `training-surveys/${itemId}`, {
						headers: AUTH_HEADER
					})
					.then(response => {
						if (!!response.data.token) {
							this.props.userTokenUpdate("admin", response.data.token);
						}

						// ===================================
						//  ERROR
						// ===================================
						if (
							response.status !== 200 ||
							(response.data.status && response.data.status !== 200)
						) {
							this.setState({
								deleteItem: {
									...this.state.deleteItem,
									deletionInProgress: false,
									deleteErrors: {
										...response.data.errors
									}
								}
							});

							this.resetItemState(itemIndex);
						}
						// ===================================
						//  SUCCESS
						// ===================================
						else {
							// Remove deleted group from local state
							// Also set success message and reset deletion stuffs
							this.setState({
								data: [...this.state.data.filter(item => item.id !== itemId)],
								deleteSuccess: response.data.message,
								deleteItem: {}
							});
						}
					})
					.catch(err => {
						this.setState({
							deleteItem: {
								...this.state.deleteItem,
								deletionInProgress: false,
								deleteErrors: err.toString()
							}
						});
						this.resetItemState(itemIndex);
					});
			}
		);
	};

	resetItemState = (itemIndex, successfull = false) => {
		this.setState({
			data: [
				...this.state.data.map((deleteItem, i) => {
					if (i !== itemIndex) {
						return deleteItem;
					}

					return {
						...deleteItem,
						saving: false,
						deleting: false,
						successfull,
						titleChanged: !successfull
					};
				})
			]
		});
	};

	// ===================================================================================
	//  RENDER
	// ===================================================================================
	render() {
		return (
			<div className="searchbar-with-button-content">
				<Button
					text={"Add New"}
					clickHandler={() =>
						this.setState({
							showNewItemDialog: true
						})
					}
					isLoading={this.state.newItemInProgress}
					isDisabled={this.state.newItemInProgress}
					classes={"searchbar-bottom-btn"}
				/>
				<div className="searchbar-with-button-content--content">
					{this.state.data.length ? (
						<div>
							{this.state.data.map((item, i) => (
								<TrainingSurveyItemAdmin
									key={i}
									item={item}
									titleChanged={this.titleChanged}
									handleInputChange={e => this.updateTitle(e, i)}
									handleDescriptionChange={e => this.updateTitle(e, i)}
									handleSubmit={() => this.handleUpdate(item)}
									deleteItem={() => {
										this.setState({
											showDeleteConfirmationDialog: true,
											deleteItem: item
										});
									}}
								/>
							))}
						</div>
					) : (
						<div>No Results</div>
					)}
					<ErrorDialog
						show={this.state.showErrorDialog}
						errors={this.state.errors}
						handleClose={() => this.setState({ showErrorDialog: false })}
					/>
					<AddNewTrainingSurveysItemDialog
						show={this.state.showNewItemDialog}
						inProgress={this.state.newItemInProgress}
						handleAdd={this.addNewItem}
						handleClose={() =>
							this.setState({
								showNewItemDialog: false,
								addSuccess: null,
								newItemError: null
							})
						}
						errors={this.state.newItemError}
						success={this.state.newItemSuccess}
					/>
					<DeleteConfirmationDialog
						show={this.state.showDeleteConfirmationDialog}
						deletionInProgress={this.state.deleteItem.deletionInProgress}
						id={this.state.deleteItem.id}
						itemTitle={this.state.deleteItem.title}
						handleDelete={this.handleDelete}
						handleClose={() =>
							this.setState({
								showDeleteConfirmationDialog: false,
								deleteSuccess: null,
								deleteItem: {}
							})
						}
						deleteErrors={this.state.deleteItem.deleteErrors}
						deleteSuccess={this.state.deleteSuccess}
					/>
				</div>
			</div>
		);
	}
}

SearchTrainingSurveys.defaultProps = {
	items: [],
	startPosition: 0,
	clickHandle: null
};

export default connect(
	null,
	{ userTokenUpdate }
)(SearchTrainingSurveys);



// WEBPACK FOOTER //
// ./src/components/admin/training-surveys/SearchTrainingSurveys.js